/**
 * The lifecycle glyphs (Figma 11115:27004): pause, play (resume) and the
 * archive box. Inline so they take `currentColor` — white on the hero's glass
 * buttons, blue / red in the banners and sheets. Always decorative: the
 * button that holds one carries the aria-label.
 */

export function PauseGlyph({ size = 20 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false">
      <rect x="6" y="4.5" width="4" height="15" rx="1.5" fill="currentColor" />
      <rect x="14" y="4.5" width="4" height="15" rx="1.5" fill="currentColor" />
    </svg>
  );
}

export function PlayGlyph({ size = 20 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false">
      <path
        d="M8 5.14v13.72a1 1 0 0 0 1.52.85l11.2-6.86a1 1 0 0 0 0-1.7L9.52 4.29A1 1 0 0 0 8 5.14Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function ArchiveGlyph({ size = 20 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false">
      <rect x="3" y="4" width="18" height="5" rx="1.5" stroke="currentColor" strokeWidth="1.8" />
      <path
        d="M5 9v9a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V9"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinejoin="round"
      />
      <path d="M10 13h4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
    </svg>
  );
}
